<template>
  <div class="left-row">
    <big-title :imgSrc="require('@/assets/images/bigScreen/icon-yq.png')" title="园区属性" style="height: 40%">
      <park-info :infoData="infoData"/>
    </big-title>
    <big-title :imgSrc="require('@/assets/images/bigScreen/icon-cz.png')" title="承租情况" style="height: 30%">
      <lessee-info :infoData="infoData"/>
    </big-title>
    <big-title :imgSrc="require('@/assets/images/bigScreen/icon-cz.png')" title="产业分布" style="height: 30%">
      <industry :coTypeNumMap="infoData.coTypeNumMap"/>
    </big-title>
  </div>
</template>

<script>
import BigTitle from './bigTitle.vue'
import ParkInfo from './parkInfo.vue'
import LesseeInfo from './lesseeInfo.vue'
import Industry from './industry.vue'
export default {
  components: {
    BigTitle,
    ParkInfo,
    LesseeInfo,
    Industry
  },
  props: {
    infoData: {
      type: Object,
      default: () => {}
    }
  }
}
</script>

<style lang="scss" scoped>
.left-row {
  position: absolute;
  left: 0.3rem;
  top: 0;
  padding: 0.1rem 0.2rem;
  box-sizing: border-box;
  width: 5.4rem;
  margin-top: 0.2rem;
  height: 95%;
  background: linear-gradient(to right, rgba(11,39,64, 0.70), rgba(10,35,57,0.33));
}
</style>